export default __webpack_public_path__ + "static/media/alert.11318e55.svg";